var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    !_vm.needVerifyOtp
      ? _c("div", { staticClass: "container content-padding" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "row justify-content-md-center mt-5" }, [
            _c("div", { staticClass: "col-md-6 text-center" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.username,
                      expression: "username"
                    }
                  ],
                  staticClass: "form-control input-lg",
                  attrs: {
                    type: "text",
                    placeholder: "Username",
                    required: ""
                  },
                  domProps: { value: _vm.username },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.username = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.password,
                      expression: "password"
                    }
                  ],
                  staticClass: "form-control input-lg",
                  attrs: {
                    type: "password",
                    maxlength: "20",
                    placeholder: "Password",
                    required: ""
                  },
                  domProps: { value: _vm.password },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.password = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-info btn-block",
                    attrs: { disabled: _vm.isLoading },
                    on: {
                      click: function($event) {
                        return _vm.login()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.loginTextButton) +
                        "\n          "
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      : _c(
          "div",
          [
            _c("sendPartnerOTP", {
              attrs: {
                username: _vm.username,
                password: _vm.password,
                emailSentOtp: _vm.emailSentOtp
              },
              on: { clearData: _vm.clearData }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row text-center" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("img", {
          staticClass: "img-fluid",
          staticStyle: { height: "85px" },
          attrs: { src: "/static/img/logo.png", alt: "logo" }
        })
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dc01833c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc01833c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partner/Login.vue
// module id = 2247
// module chunks = 0